import {useMutation} from '@tanstack/react-query';
import {getRefundTableUrl} from '../../services/getRefundTableUrl';
import {UseGetRefundTableUrlMutationProps} from './types';

export const useGetRefundTableUrlMutation = ({
	onMutate,
	onSuccess,
}: UseGetRefundTableUrlMutationProps) =>
	useMutation({
		mutationFn: () => getRefundTableUrl(),
		onMutate,
		onSuccess,
	});
